"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _StaticMarkdown = _interopRequireDefault(require("./StaticMarkdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _StaticMarkdown["default"];
exports["default"] = _default;